import React from 'react';
import { Link } from 'react-router-dom';

function SolutionsFooter() {
  return (
    <>
      {/* Final CTA */}
      <section className="py-20 md:py-28 px-8 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-medium mb-6 tracking-tight">
            Ready to see what's possible?
          </h2>
          <p className="text-lg text-gray-300 mb-10 leading-relaxed max-w-2xl mx-auto">
            Whether you're exploring the platform or need expert guidance on a high-stakes decision, 
            we're here to help you move forward with confidence.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/contact">
              <button className="bg-white text-gray-900 px-8 py-4 rounded text-base font-medium hover:bg-gray-100 transition-colors min-w-[220px]">
                Schedule a conversation
              </button>
            </a>
            <a href="https://app.veydra.io">
              <button className="border border-gray-600 text-white px-8 py-4 rounded text-base font-medium hover:border-gray-400 transition-colors min-w-[220px]">
                Request Immediate Access
              </button>
            </a>
          </div>
        </div>
      </section>
    <footer className="bg-gray-50 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-8 py-12 md:px-16">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center mb-4 md:mb-0">
            <Link to="/" className="flex items-center mr-4">
              <img src="/logo.svg" className="h-6 w-6" alt="Veydra" />
              <span className="ml-2 text-lg font-medium text-gray-900 tracking-tight">Veydra</span>
            </Link>
          </div>
          <div className="flex flex-col md:flex-row items-center space-y-3 md:space-y-0 md:space-x-6">
            <Link to="/" className="text-sm text-gray-600 hover:text-gray-900">Home</Link>
            <Link to="/solutions" className="text-sm text-gray-600 hover:text-gray-900">Solutions</Link>
            <Link to="/resources" className="text-sm text-gray-600 hover:text-gray-900">Resources</Link>
            <Link to="/contact" className="text-sm text-gray-600 hover:text-gray-900">Contact</Link>
            <Link to="/privacy" className="text-sm text-gray-600 hover:text-gray-900">Privacy</Link>
          </div>
        </div>
      </div>
    </footer>
    </>
  );
}

export default SolutionsFooter;
